import React, { useRef } from 'react';

import { KeyboardAvoidingView } from '@rbilabs/universal-components';

import { BasicInput } from 'components/basic-input';

import { TransactionInputFormContainer } from '../loyalty-claim-points.styled';

interface TransactionInputFormProps {
  setCodeValue: (val: string) => void;
}

const TransactionInputForm = ({ setCodeValue }: TransactionInputFormProps) => {
  const inputsRef = useRef<{ [key: string]: any }>({});
  const fieldsValues = useRef({});

  const fields = [
    {
      name: 'first',
      maxLength: 5,
      focusNext: () => inputsRef.current.second?.focus(),
      autoFocus: true,
    },
    {
      name: 'second',
      maxLength: 5,
      focusNext: () => inputsRef.current.third?.focus(),
      focusBack: () => inputsRef.current.first?.focus(),
    },
    {
      name: 'third',
      maxLength: 5,
      focusNext: () => inputsRef.current.fourth?.focus(),
      focusBack: () => inputsRef.current.second?.focus(),
    },
    {
      name: 'fourth',
      maxLength: 6,
      focusBack: () => inputsRef.current.third?.focus(),
    },
  ];

  const handleChange = (inputName: string, newInputValue: string) => {
    fieldsValues.current = { ...fieldsValues.current, [inputName]: newInputValue };
    const transactionId = fields.map(({ name }) => fieldsValues.current[name]).join('');
    setCodeValue(transactionId);
  };

  return (
    <KeyboardAvoidingView>
      <TransactionInputFormContainer>
        {fields.map(({ name, ...field }) => (
          <BasicInput
            flex={1}
            {...field}
            key={name}
            name={name}
            type="number"
            keyboardType="numeric"
            onFieldChange={handleChange}
            setRef={(instance: any) => (inputsRef.current[name] = instance)}
          />
        ))}
      </TransactionInputFormContainer>
    </KeyboardAvoidingView>
  );
};

export default TransactionInputForm;
